import { render, staticRenderFns } from "./Spots.vue?vue&type=template&id=702dea4d&"
import script from "./Spots.vue?vue&type=script&lang=js&"
export * from "./Spots.vue?vue&type=script&lang=js&"
import style0 from "./Spots.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports